import Image from 'next/image';

interface PoweredByProps {
  variant?: 'full' | 'logo-only';
  className?: string;
  logoClassName?: string;
}

export function PoweredBy({ variant = 'full', className = '', logoClassName = '' }: PoweredByProps) {
  if (variant === 'logo-only') {
    return (
      <Image
        src="/rekpo-logo.png"
        alt="REKPO.ai Logo"
        width={120}
        height={40}
        className={logoClassName || 'h-10 w-auto'}
      />
    );
  }

  return (
    <div className={`flex flex-col items-center ${className}`}>
      <Image
        src="/gallaghermohan_logo.png"
        alt="Gallagher Mohan"
        width={192}
        height={48}
        className={logoClassName || 'mb-4 w-48 h-auto'}
      />
      <p className="text-sm text-gray-500 mb-2">powered by</p>
      <Image
        src="/rekpo-logo.png"
        alt="REKPO"
        width={96}
        height={32}
        className="mb-6 w-24 h-auto"
      />
    </div>
  );
}
